import { Link, useLocation } from "react-router-dom";
import { ChevronDown, LayoutDashboard } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const VIEWS = [
  { to: "/admin", label: "Admin dashboard" },
  { to: "/dashboard", label: "Shop dashboard" },
  { to: "/sales", label: "Sales rep dashboard" },
  { to: "/webadvisor/leads", label: "Web Advisor pipeline" },
  { to: "/admin/sales-training", label: "Sales training center" },
  { to: "/sales/manager", label: "Sales team performance" },
  { to: "/admin/claim-campaign", label: "Claim campaign center" },
  { to: "/shop/repair-orders", label: "Shop operations" },
  { to: "/onboarding-show", label: "Onboarding presentation" },
  { to: "/admin/training-shots", label: "Training screenshots" },
];

export const DashboardSwitcher = () => {
  const { pathname } = useLocation();
  const current = [...VIEWS].sort((a, b) => b.to.length - a.to.length).find(v => pathname.startsWith(v.to)) || VIEWS[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="bg-blue-600 hover:bg-blue-500 text-white font-medium px-4 py-2 rounded-lg transition-colors text-sm flex items-center gap-1.5" data-testid="dashboard-switcher">
          <LayoutDashboard className="w-4 h-4" />{current.label.replace(" dashboard", "")}<ChevronDown className="w-3.5 h-3.5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white w-56">
        <DropdownMenuLabel className="text-xs text-slate-400">Switch dashboard</DropdownMenuLabel>
        {VIEWS.map(v => (
          <DropdownMenuItem key={v.to} asChild>
            <Link to={v.to} className={`cursor-pointer ${current.to === v.to ? "font-bold text-blue-600" : ""}`} data-testid={`dashboard-switch-${v.to.replace(/\//g, "-").slice(1)}`}>{v.label}</Link>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/admin?tab=users" className="cursor-pointer text-xs text-slate-500" data-testid="dashboard-switch-view-as">View as a specific user…</Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
